import React, { useState } from 'react';
import './iniSes.css';
import { useNavigate } from 'react-router-dom';
const InicioSesion = () => {
  const navigate = useNavigate();  
  const [formData, setFormData] = useState({
    nombre: '',
    password: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch('https://frabas.cl/backend/Sesion.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();
    console.log(formData);
    console.log(data);


    if (data.success) {
      // Aquí podrías guardar un token, redirigir, etc.
      alert('Inicio de sesión exitoso',data.data);


      localStorage.removeItem('datosUsuario');
      localStorage.setItem('datosUsuario', JSON.stringify(data.data));

      navigate('/'); // o usa useNavigate si estás con React Router
    } else {
      alert(data.message || 'Usuario o contraseña incorrectos');
    }
  } catch (error) {
    console.error('Error usuario o contraseña incorrectos:', error);
    alert('Error al conectar con el servidor');
  }
};


  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Iniciar Sesión</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nombre">Usuario</label>
            <input
              type="nombre"
              id="nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="login-button">
            Ingresar
          </button>
        </form>
        <div className="login-footer">
          <a href="/recuperar" className="forgot-password">¿Olvidaste tu contraseña?</a>
          <p className="register-link">
            ¿No tienes una cuenta? <a href="/register">Regístrate</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default InicioSesion;
